import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../router/all_routes";
import BasicDetails from "./BasicDetails";
// import Gurantors from "./Gurantors";
// import Representatives from "./Representatives";
// import Partners from "./Declaration";
// import Enclosures from "./Enclosures";
// import Payment from "./Payment";
// import { getAllAPMC } from "../../auth/services/apiCalling";
import { useSelector } from "react-redux";
import Education from "./Education";
import ExperienceForm from "./Experience";
import Declaration from "./Declaration";
import { getApplicationExistencCheck, getDraftApplication, getPanelDraftApplication } from "../../auth/services/privateapicalling";
import { getAllAPMC, getAllDistricts } from "../../auth/services/apiCalling";
// import ReCAPTCHA from "react-google-recaptcha";
import _ from "lodash";
import { ToastContainer } from "react-toastify";

export interface APMC {
  Department_Idetifier: string;
  District: string;
}

export interface Option {
  value: string;
  label: string;
}

export interface APMCResponse {
  success: boolean;
  data: any[];
  message: string;
}

const PanelEngineerLicenseRegistrationForm = () => {
  const routes = all_routes;
  const [accepted, setAccepted] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [districtOptions, setDistrictOptions] = useState<Option[]>([]);
   const [districtAddressOptions, setDistrictAddressOptions] = useState<Option[]>([]);
  
  const [formData, setFormData] = useState<any>({});
  const token = useSelector((state:any)=>state.auth.token)
   const language = useSelector((state:any)=>state.auth.language);
  // const [apmcOptions, setApmcOptions] = useState<Option[]>([]);
   const  [isAllowed,setIsAllowed] = useState(true);
    const [existData ,setExistData] = useState<any | null>(null);
    const [applicationId , setApplicationID] = useState<string | null>(null);
      const [isBasicDetailFilled , setIsBasicDetailFilled] = useState(false);
      const [loading , setLoading] = useState(false)
      const [stepState , setStepState] = useState(false);
      const [statusFlags, setStatusFlags] = useState({
        isEducationFilled: false,
        isExperienceFilled: false,
        isDeclarationFilled: false,
      });
        const [selectData, setSelectData] = useState({
              district: '',
              taluka: '',
              addressToUpdate:''
            });
      const [talukaOptionsCurr , setTalukaOptionsCurr] = useState<Option[]>([]);
       
        const [talukaOptionsPer , setTalukaOptionsPer] = useState<Option[]>([]);
        
        const [talukaOptionsReg , setTalukaOptionsReg] = useState<Option[]>([]);

  const steps = [
      { name: language.basic_detail, key: "basic_details" },
      { name: language.education_details, key: "education" },
      { name: language.experience_details, key: "experience" },
      { name: language.declarations, key: "declaration" }
  ];

  // Handle input change
  type StepKey = "basic_details" | "education" | "experience" | "declaration" ;
 
 const fetchAllDistrictTaluka = async (token: string, district?: string, taluka?: string, toUpdateDistOpt?: string): Promise<Option[]> => {
   try {
     let dist = district || (existData ? existData?.department?.district_id : '');
     let tal = taluka || '';
 
     
 
     const response = await getAllAPMC(token, dist, tal);
 
     if (dist && !tal) {
       // Load Talukas
       const talukas = response.data.map((t) => ({
         label: t.Taluka,
         value: t.Taluka,
       }));
 
       // Clear and set the appropriate taluka options
       
       if (toUpdateDistOpt === "curr") {
         setTalukaOptionsCurr(talukas);
       }
       if (toUpdateDistOpt === "per") {
         setTalukaOptionsPer(talukas);
       }
       if (toUpdateDistOpt === "reg") {
         setTalukaOptionsReg(talukas);
       }
 
     } else if (dist && tal) {
       // Load APMCs
       const apmcs = response.data.map((a) => ({
         label: a.apmcName,
         value: a.id,
       }));
       
    
     }
 
     return response.data;
   } catch (error) {
   
     return [];
   }
 };
    const fetchApplicationIfExist = async () => {
      try {
        setLoading(true);
        //.log("fetchApplicationIfExist fetchApplicationIfExist");
    
        const data = await getPanelDraftApplication(token);
        //.log("draft data", data);
        // setPaymentStatus( data?.status.paymentStatus)
  
        setIsBasicDetailFilled(data?.userDetail?.isBasicDetailFilled);
  

    
        const stepConditions: { condition: boolean; step: number }[] = [
          { condition: !data?.userDetail?.isBasicDetailFilled, step: 0 },
          { condition: !data?.userDetail?.isRepresentativeFilled, step: 1 },
          { condition: !data?.userDetail?.ifFirmDetailFilled, step: 2 },
          { condition: !data?.userDetail?.isEnclouserFilled, step: 3 },
          { condition: !data?.userDetail?.isGurantorFilled, step: 4 },
          { condition: (data?.status.paymentStatus === "PENDING" || data?.status.paymentStatus === "FAILED"), step: 5 },
          { condition: data?.status.paymentStatus == null ||  data?.status.paymentStatus =="SUCCESS" , step: 0 }
  
        ];
  
        // const stepConditions: { name?: string; key?: string; condition?: boolean; step?: number }[] = [
        //   { name: "Basic Details", key: "basic_details" },
        //   { name: "Representatives", key: "representatives" },
        //   { name: "Partners", key: "partners" },
        //   { name: "Enclosures & Declarations", key: "enclosures" },
        //   { name: "Guarantors", key: "guarantors" },
        
        //   // Conditional steps for payment status
        //   { condition: data?.status.paymentStatus === "PENDING" || data?.status.paymentStatus === "FAILED", step: 5 },
        //   { condition: data?.status.paymentStatus == null || data?.status.paymentStatus === "SUCCESS", step: 0 }
        // ];
        
        // Determine the next step based on conditions
        // const nextStep = stepConditions.find(({ condition }) => condition)?.step;
        // const nextStep = setCurrentStep((prev) => (prev < 5  ? prev + 1 : prev));
        
        // if (nextStep !== undefined) {
        //   setCurrentStep(nextStep);
        // } else if (data?.status.paymentStatus === "done") {
        //   // If all steps are done and payment is completed, set to the last step
        //   setCurrentStep(stepConditions.length - 1);
        // }
        
       
    
        // Only update currentStep if any step is pending
        // const nextStep = stepConditions.find(({ condition }) => condition)?.step;
        // if (nextStep !== undefined) {
        //   setCurrentStep(nextStep);
        // } else if (data?.status.paymentStatus === "done") {
        //   // If all steps are done and payment is completed, set to the last step
        //   setCurrentStep(steps.length - 1);
        // }
      } catch (err) {
        //.log("No application found");
      } finally {
        setLoading(false);
      }
    };
    

  const fetchApplicationExistenceCheck = async() => {
    const getData = await getApplicationExistencCheck(token);
    //.log('payment status', getData)
    setIsAllowed(getData?.data?.isAllowed);
    
    setExistData(getData?.data);
    setApplicationID(getData?.data?.applicationId);
    setStepState(true);

  }   
  

    useEffect(() => {
    if (!existData) return;
  
    // Load POB data
    if (existData?.department?.district_id) {
      fetchAllDistrictTaluka(token, existData.department.district_id, "", "pob");
    }
  
    // Load current address data
    if (existData?.currAddress?.[0]?.district && existData?.currDistrictId) {
      fetchAllDistrictTaluka(token, existData.currDistrictId, "", "curr");
    }
  
    // Load permanent address data
    if (existData?.perAddress?.[0]?.district && existData?.perDistrictId) {
      fetchAllDistrictTaluka(token, existData.perDistrictId, "", "per");
    }
  
    // Load registered office address data
    if (existData?.regOffAddress?.[0]?.district && existData?.regDistrictId) {
      fetchAllDistrictTaluka(token, existData.regDistrictId, "", "reg");
    }
  }, [existData]);
  const fetchAllDistrict = async (token: string): Promise<Option[]> => {
    try {
      const response = await getAllDistricts(token);
        const res = await getAllAPMC(token , '' , '');
      //.log('resss', response)
      // response.data:[]
      const district: APMC[] = response.data;
      //.log(' district Data', district)

      const options: Option[] = district.map((dist) => ({
        value: dist?.Department_Idetifier,
        label: dist?.District,
      }));
   const districts = res.data.map((d) => ({
        label: d.District,
        value: d.district_id,
      }));
      setDistrictAddressOptions(districts);
      //.log('Options:', options);
      return options;
    } catch (error) {
      //.error('Error fetching APMC data:', error);
      return [];
    }
  };

   useEffect(() => {
    fetchAllDistrict(token).then((options) => setDistrictOptions(options));
    fetchApplicationIfExist();
    fetchApplicationExistenceCheck();
    
  }, []); 



  useEffect(() => {
    if (_.isEmpty(existData)) return;
  
    const newStatusFlags = {
      isEducationFilled: !_.isEmpty((existData as any).eduQualification),
      isExperienceFilled:
        _.every(
          [
            (existData as any).experienceDetail,
            (existData as any).govSemiGovExpDetail,
            (existData as any).marketPublicConstructionDetail,
          ],
          (arr: any) => !_.isEmpty(arr)
        ) &&
        !_.isEmpty((existData as any).itReturnDetail) &&
        ((existData as any).yrOfExpAsBusErr && (existData as any).yrOfExpAsBusErr !== "0"),
      isDeclarationFilled: !_.isEmpty((existData as any).declarationDetail),
    };
  
    setStatusFlags(newStatusFlags);
  
    // ✅ If all other fields are false, basic details should also be false
    const isBasicDetailsFilled =
      newStatusFlags.isEducationFilled ||
      newStatusFlags.isExperienceFilled ||
      newStatusFlags.isDeclarationFilled;
  
    const flagKeys = [
      isBasicDetailsFilled, // ✅ Now, Basic Details is false if all are false
      newStatusFlags.isEducationFilled,
      newStatusFlags.isExperienceFilled,
      newStatusFlags.isDeclarationFilled,
    ];
  
    const firstUnfilledIndex = flagKeys.findIndex((filled) => !filled);
  
    // ✅ If all steps are false, set to step 0
    setCurrentStep(firstUnfilledIndex !== -1 ? firstUnfilledIndex : 0);
  }, [stepState]);
  

   
  const handleNext = async(data?: any) => {
    if (data) {
      setFormData((prev: any) => ({  ...data }));
      if(!formData)
      {
        //.log('no data found ')

      }
      else{
        await handleSubmit(data);
        fetchApplicationExistenceCheck();

      }
    }
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };


  const handlePrev = () => {
    setCurrentStep((prev) => (prev > 0 ? prev - 1 : prev));
    fetchApplicationExistenceCheck();

  }; 

  const handleSubmit = async(data:any)=>{
    //.log('form dataaa' , formData)
    //.log('dddddd' , data)
 
  }

  const onAdd = async () => {
    //.log('fetchApplicationExistenceCheck');  
    fetchApplicationExistenceCheck()
  } 
 
  const renderFormFields = () => {
      const stepKey = steps[currentStep].key;
      switch (stepKey) {
          case "basic_details":
              return (
                <div>{ districtOptions && existData && <BasicDetails  districtOptions={districtOptions}
                districtAddressOptions={districtAddressOptions}
                 fetchAllDistrictTaluka={fetchAllDistrictTaluka}
                     talukaOptionsCurr={talukaOptionsCurr}
                      selectData={selectData} setSelectData={setSelectData}
                  talukaOptionsReg={talukaOptionsReg} onNext={handleNext}   existData={existData} isAllowed={isAllowed}  isBasicDetailFilled={isBasicDetailFilled} />}</div>
              );
              
          case "education":
            return (
              <div> {existData &&  <Education 
                onNext={handleNext} onPrev={handlePrev}  
                existData={existData} onAdd={onAdd} 
                fetchApplicationExistenceCheck={fetchApplicationExistenceCheck}
                isEducationFilled={statusFlags.isEducationFilled} />}</div> 
              );

          case "experience":
              return (
                <div>{existData && <ExperienceForm 
                   onNext={handleNext} onPrev={handlePrev}  
                   fetchApplicationExistenceCheck={fetchApplicationExistenceCheck}
                   existData={existData} onAdd={onAdd} isExperienceFilled={statusFlags.isExperienceFilled} />}</div>
              );
          case "declaration":
              return (
               <div>{existData &&  <Declaration  existData={existData} isDeclarationFilled={statusFlags.isDeclarationFilled} onPrev={handlePrev}  />}</div>
              );
      
          default:
              return null;
      }
  };
 
  

  return (
    <div>
      <div className="cardhead page-wrapper">
        <div className="container-fluid content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">{language.license} -</h3>
              
              </div>
            </div>
          </div>
          {/* /Page Header */}
         
          <div className="row">
            <div className="col-md-12">
              <div className="card">
              
                <>   
             <div className="card-body">
             <div className="container mt-4">
            {/* Pipeline Navigation */}
            <div className="d-flex flex-wrap border-0 justify-content-center candidates mb-0 mb-4 pipeline-list">
                <ul className="d-flex flex-wrap list-unstyled mb-0 justify-content-center">
                    {steps.map((step, index) => (
                        <li key={index} className="mx-2 my-2">
                            <Link
                                to="#"
                                className={`px-3 py-2 d-inline-block rounded 
                                    ${index <= currentStep ? "bg-info text-white" : "bg-gray-100 text-dark"}`}
                            >
                                <span className="text-nowrap">{step.name}</span>
                                
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Form Sections */}
          
            <div className="p-4">
              {renderFormFields()}
              {/* <div className="d-flex justify-content-between">
                  {currentStep > 0 && (
                      <button type="button" className="btn btn-secondary" onClick={handlePrev}>
                          Previous
                      </button>
                  )}
                  {currentStep < steps.length - 1 && (
                      <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                          Next
                      </button>
                  )}
              </div> */}
          </div>
        </div>
             </div></>
             
            
              </div>
            </div>
          </div>
      
        </div>
      </div>
            {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              Loading...
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PanelEngineerLicenseRegistrationForm;
